import React, { useState } from 'react';
import {
  Container,
  Section,
  Button,
  Stack,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@tonic/shared/components/ui'
import { PageTitle } from "@/components/ui/PageTitle";
import { GlobalOverviewDashboard } from '../components/global-overview';
import { QuickLinks } from '../components/global-overview/quick-links';
import {
  Download,
  Share2,
  RefreshCw,
  Calendar,
  MoreVertical,
  FileText,
  Mail,
  Printer,
  Settings,
} from 'lucide-react';

const TIME_RANGES = [
  { label: 'Last 7 days', value: 'WEEK' },
  { label: 'Last 30 days', value: 'MONTH' },
  { label: 'Last 90 days', value: 'QUARTER' },
  { label: 'Last year', value: 'YEAR' },
];

export function DashboardPage() {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [selectedTimeRange, setSelectedTimeRange] = useState('MONTH');
  const [showExportDialog, setShowExportDialog] = useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    // TODO: Implement refresh functionality
    await new Promise(resolve => setTimeout(resolve, 1000));
    setIsRefreshing(false);
  };

  const handleExport = async format => {
    // TODO: Implement export functionality
    console.log(`Exporting dashboard in ${format} format...`);
    setShowExportDialog(false);
  };

  const handleShare = () => {
    // TODO: Implement share functionality
    console.log('Sharing dashboard...');
  };

  const handleTimeRangeChange = range => {
    setSelectedTimeRange(range);
    // TODO: Implement time range change functionality
    console.log(`Changed time range to ${range}`);
  };

  const actions = (
    <div className="flex items-center gap-2">
      <Button variant="outline" size="sm" onClick={handleRefresh} disabled={isRefreshing}>
        <RefreshCw className={`w-4 h-4 mr-2 ${isRefreshing ? 'animate-spin' : ''}`} />
        Refresh
      </Button>
      <Button variant="outline" size="sm" onClick={() => setShowExportDialog(true)}>
        <Download className="w-4 h-4 mr-2" />
        Export
      </Button>
      <Button variant="outline" size="sm" onClick={handleShare}>
        <Share2 className="w-4 h-4 mr-2" />
        Share
      </Button>
    </div>
  );

  return (
    <Container>
      <Stack space={6}>
        <div className="space-y-6">
          <div className="flex flex-col space-y-6 lg:flex-row lg:items-start lg:justify-between lg:space-y-0">
            <PageTitle
              title="Dashboard"
              description="Overview of your business performance"
              actions={actions}
            />
            <div className="lg:w-auto">
              <QuickLinks />
            </div>
          </div>
        </div>
        <GlobalOverviewDashboard timeRange={selectedTimeRange} />
      </Stack>

      <Dialog open={showExportDialog} onOpenChange={setShowExportDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Export Dashboard</DialogTitle>
          </DialogHeader>
          <Stack space={4}>
            <Button variant="outline" className="justify-start" onClick={() => handleExport('pdf')}>
              <FileText className="w-4 h-4 mr-2" />
              Export as PDF
            </Button>
            <Button
              variant="outline"
              className="justify-start"
              onClick={() => handleExport('excel')}
            >
              <FileText className="w-4 h-4 mr-2" />
              Export as Excel
            </Button>
            <Button variant="outline" className="justify-start" onClick={() => handleExport('csv')}>
              <FileText className="w-4 h-4 mr-2" />
              Export as CSV
            </Button>
          </Stack>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowExportDialog(false)}>
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Container>
  );
}
